'use strict';

import angular from 'angular';

function GrpTxnResource($resource) {
  return $resource('/api/groups/:groupId/transactions/:id/:controller', {
    id: '@id'
  }, {
    queryMembers: {
      method: 'GET',
      params: {controller: 'members'},
      isArray: true
    },
    queryValidToGroups: { // toGroups ancestors of GroupId w/ feesa
      method: 'GET',
      params: {controller: 'validtogroups'},
      isArray: true
    },
    create: {
      method: 'POST'
    },
    update: { method: 'PUT' }
  });
}

GrpTxnResource.$inject = ['$resource'];

export default angular.module('georgeApp.grpTxnSvc', [])
  .factory('GrpTxnSvc', GrpTxnResource)
  .name;
